export default __webpack_public_path__ + "static/media/PulseOximeter.cfe730a7.svg";